import { jsx as _jsx } from "react/jsx-runtime";
import { CatAccordion } from '@blocks-react/components/Accordion';
export function FooterAccordion({ children }) {
    return _jsx(CatAccordion, { inverted: true, children: children });
}
